module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.checkClientWidth) ? _c('div', {
    staticClass: "sidemenu-open",
    class: {
      'sidebar-closed': _vm.sidebarOpen
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "padding": "10px",
      "height": "50px",
      "border-top-right-radius": "7px",
      "background-color": "#2d2d30",
      "border-bottom-right-radius": "7px",
      "box-shadow": "2px 3px 15px 0px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selectedSubmenuArray.length > 0 || _vm.routerSubMenuActive) ? _c('a', {
    staticStyle: {
      "color": "#fffdfc",
      "font-size": "22px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectedSubmenuArray.pop();
        _vm.routerSubMenuActive = false
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Atpakaļ "), _c('i', {
    staticClass: "chevron left icon"
  })])]) : _vm._e()])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0",
      "width": "97%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#2d2d30",
      "border-top-right-radius": "7px",
      "border-bottom-right-radius": "7px",
      "box-shadow": "2px 3px 15px 0px",
      "overflow-x": "scroll"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#fffdfc",
      "font-size": "22px",
      "padding-left": "10px",
      "height": "30px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selectedSubmenuArray[_vm.selectedSubmenuArray.length - 1]) ? _c('span', [_vm._v(_vm._s(_vm.selectedSubmenuArray[_vm.selectedSubmenuArray.length - 1].category))]) : (_vm.routerSubMenuActive) ? _c('span', [_vm._v("Mani dati")]) : _c('span')])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('ul', {
    staticClass: "submenu-list submenu-level1",
    class: {
      'is-active': _vm.selectedSubmenuArray.length == 0 && !_vm.routerSubMenuActive
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "home icon"
  }), _vm._v(" Sākums\n              ")])], 1), _vm._v(" "), (_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('div', {
    staticClass: "item repeat-last-order",
    on: {
      "click": _vm.repeatLastOrder
    }
  }, [_c('i', {
    staticClass: "repeat icon"
  }), _vm._v("Atkārtot grozu\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.role > 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'waiting-for-delivery'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "hourglass start icon"
  }), _vm._v("\n                Gaida piegādi "), (_vm.itemsWaitingForDelivery > 0) ? _c('span', {
    staticStyle: {
      "height": "100%",
      "padding-left": "8px",
      "padding-right": "8px",
      "padding-top": "3px",
      "padding-bottom": "3px",
      "background-color": "#0b87e0",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.itemsWaitingForDelivery))]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.role > 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'autoship'
      }
    }
  }, [_c('i', {
    staticClass: "retweet icon"
  }), _vm._v(" AutoShip\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_c('i', {
    staticClass: "shopping basket icon"
  }), _vm._v(" Preces\n              ")])], 1), _vm._v(" "), _vm._l((_vm.mobileViewCategory), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.menuItemClicked(item, 1)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.category)), (item.category_a.length > 0) ? _c('i', {
      staticClass: "caret right icon"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.user.role > 0) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.role > 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'topup'
      }
    }
  }, [_c('i', {
    staticClass: "euro icon"
  }), _vm._v(" Papildināt kontu\n              ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.routerSubMenuActive = true;
        _vm.selectedSubmenuArray.length = 0
      }
    }
  }, [(_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('a', [_c('i', {
    staticClass: "cog icon"
  }), _vm._v("\n                Mani dati "), _c('i', {
    staticClass: "caret right icon"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('i', {
    staticClass: "power icon"
  }), _c('span', [_vm._v("Iziet")])])], 1) : _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    staticClass: "right item",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "power icon"
  }), _vm._v(" "), _c('span', [_vm._v("Ienākt/Log-in")])])], 1)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selectedSubmenuArray[0]) ? _c('ul', {
    staticClass: "submenu-list submenu-level2",
    class: {
      'is-active': _vm.selectedSubmenuArray.length == 1
    }
  }, _vm._l((_vm.selectedSubmenuArray[0].category_a), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.menuItemClicked(item, 2)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.category)), (item.category_b.length > 0) ? _c('i', {
      staticClass: "caret right icon"
    }) : _vm._e()])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selectedSubmenuArray[1]) ? _c('ul', {
    staticClass: "submenu-list submenu-level3",
    class: {
      'is-active': _vm.selectedSubmenuArray.length == 2
    }
  }, _vm._l((_vm.selectedSubmenuArray[1].category_b), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.menuItemClicked(item, 3)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.category))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.routerSubMenuActive) ? _c('ul', {
    staticClass: "submenu-list submenu-level3",
    class: {
      'is-active': _vm.routerSubMenuActive
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    staticClass: "item repeat-last-order",
    attrs: {
      "to": {
        name: 'user-profile'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v(" Profila informācija\n                ")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'user-address'
      }
    }
  }, [_c('i', {
    staticClass: "marker icon"
  }), _vm._v(" Piegādes adreses\n                ")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.export_to_ramus == 1) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'user-rented-goods'
      }
    }
  }, [_c('i', {
    staticClass: "sticky note icon"
  }), _vm._v("Lietošanā esošās preces\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'user-invoices'
      }
    }
  }, [_c('i', {
    staticClass: "shopping basket icon"
  }), _vm._v("Izpildītie pasūtījumi\n                ")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.export_to_ramus == 1) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'user-monthly-bills'
      }
    }
  }, [_c('i', {
    staticClass: "history icon"
  }), _vm._v(" Ikmēneša rēķini\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [(_vm.user.export_to_ramus == 1) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'user-bills'
      }
    }
  }, [_c('i', {
    staticClass: "sticky note outline icon"
  }), _vm._v(" Avansa rēķini\n                ")]) : _vm._e()], 1)]) : _vm._e()])], 1)])])]) : _c('div', {
    staticClass: "ui custom_brown stackable inverted menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'home'
      },
      "active-class": "active",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "home icon"
  }), _vm._v(" Sākums\n    ")]), _vm._v(" "), (_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.repeatLastOrder
    }
  }, [_c('i', {
    staticClass: "repeat icon"
  }), _vm._v("Atkārtot grozu\n    ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'goods'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "shopping basket icon"
  }), _vm._v(" Preces\n    ")]), _vm._v(" "), (_vm.user.role > 0) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'waiting-for-delivery'
      },
      "active-class": "active",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "hourglass start icon"
  }), _vm._v(" "), (_vm.itemsWaitingForDelivery > 0) ? _c('div', {
    staticClass: "floating ui green label"
  }, [_vm._v(_vm._s(_vm.itemsWaitingForDelivery))]) : _vm._e(), _vm._v("\n      Gaida piegādi\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'autoship'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "retweet icon"
  }), _vm._v(" AutoShip\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'topup'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "euro icon"
  }), _vm._v(" Papildināt kontu\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0 && _vm.user.export_to_ramus == 1) ? _c('div', {
    staticClass: "ui simple dropdown item"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v("\n      Mani dati\n      "), _c('div', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-profile'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v(" Profila informācija\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-address'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "marker icon"
  }), _vm._v(" Piegādes adreses\n        ")]), _vm._v(" "), (_vm.user.export_to_ramus == 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-rented-goods'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "sticky note icon"
  }), _vm._v("Lietošanā esošās preces\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-invoices'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "shopping basket icon"
  }), _vm._v("Izpildītie pasūtījumi\n        ")]), _vm._v(" "), (_vm.user.export_to_ramus == 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-monthly-bills'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "history icon"
  }), _vm._v(" Ikmēneša rēķini\n        ")]) : _vm._e(), _vm._v(" "), (_vm.user.export_to_ramus == 1) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'user-bills'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "sticky note outline icon"
  }), _vm._v(" Avansa rēķini\n        ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0) ? _c('router-link', {
    staticClass: "right item",
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_c('i', {
    staticClass: "power icon"
  }), _c('span', [_vm._v("Iziet")])]) : _c('router-link', {
    staticClass: "right item",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "power icon"
  }), _vm._v(" "), _c('span', [_vm._v("Ienākt/Log-in")])])], 1), _vm._v(" "), (_vm.checkClientWidth) ? _c('a', {
    staticClass: "sidebar-menu-button",
    class: {
      'sidebar-menu-button-closed': _vm.sidebarOpen
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sidebarOpen = !_vm.sidebarOpen
      }
    }
  }, [_c('div', {
    staticClass: "hamburger",
    class: {
      'is-active': !_vm.sidebarOpen, 'hide-hamburger': !_vm.sidebarOpen
    },
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "3px",
      "padding-left": "13px",
      "padding-right": "10px",
      "background-color": "#2d2d30",
      "border-top-right-radius": "7px",
      "border-bottom-right-radius": "7px",
      "box-shadow": "2px 3px 10px 0px #3a3a3a"
    },
    attrs: {
      "id": "hamburger-6"
    }
  }, [_c('span', {
    staticClass: "line",
    class: {
      'line-closed': !_vm.sidebarOpen
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    class: {
      'line-closed': !_vm.sidebarOpen
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    class: {
      'line-closed': !_vm.sidebarOpen
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57e0d1d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMenu.vue
// module id = 346
// module chunks = 1